import React, { Component } from 'react';
import util from '../utils/util'
import StreamItem from '../components/StreamItem'
import UPDATES from '../data/dummy'
import {shuffle, set} from 'lodash'
import {RaisedButton, FlatButton, TextField, Dialog, FontIcon} from 'material-ui'

class Stream extends Component {
	constructor(props) {
	    super(props);

	    this.state = {
	    	update_index_selected: -1,
	    	calling: null
	    }

	    this.showCalling = this.showCalling.bind(this)
	    this.dismissCall = this.dismissCall.bind(this)
	}

	componentDidMount() {

	}

	showCalling(author) {
		this.setState({calling: author}, () => {
			this.ring_int = window.setInterval(() => {
				util.play_ring()
			}, 2000)
		})
	}

	dismissCall() {
		this.setState({calling: null}, () => {
			if (this.ring_int != null) window.clearInterval(this.ring_int)
		})
	}

    gotoMode(mode) {
    	this.setState({mode: mode})
    }

    openDetail(id) {
    	this.setState({update_index_selected: id})
    }

	render() {
		let {update_index_selected, calling} = this.state
		let title = ""
		let update_author = ""
		let IC_ST = {fontSize: "150px"}
		let call_dialog = <Dialog title={`Calling ${calling}...`} 
							open={calling != null} 
							autoDetectWindowHeight
							actions={[<FlatButton label="Dismiss" onClick={this.dismissCall} />]}
							onRequestClose={this.dismissCall}>
							<div align="center"><img src={`${process.env.PUBLIC_URL}/media/calling.gif`} width="200" /></div>
						  </Dialog>
		return (
			<div className="Stream">
				{ call_dialog }
				{ UPDATES.map((u, i) => {
					return <StreamItem key={i} data={u} 
								onReply={this.openDetail.bind(this, i)}
								onCall={this.showCalling} />
				})}
			</div>
		)
	}
}

Stream.defaultProps = {
}

export default Stream;


// WEBPACK FOOTER //
// ./src/components/Stream.js